import { render, staticRenderFns } from "./GroupMembersModal.vue?vue&type=template&id=4c48f66e&scoped=true"
import script from "./GroupMembersModal.vue?vue&type=script&lang=js"
export * from "./GroupMembersModal.vue?vue&type=script&lang=js"
import style0 from "./GroupMembersModal.vue?vue&type=style&index=0&id=4c48f66e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c48f66e",
  null
  
)

export default component.exports